import { Fragment, useRef } from 'react'

import { Seo } from '../components'
import Button from '../components/tailwind/Button'
import PageHeading from '../components/tailwind/PageHeading'
import AivyAssistantIntro from '../features/assistant-intro/AivyAssistantIntro'

// Interne Showcase-Seite (nicht in der Sidebar verlinkt): Karl Klammer → Aivy Assistent
const AssistantIntro = () => {
  const introRef = useRef(null)

  return (
    <Fragment>
      <Seo title='Aivy Assistent Intro' />
      <PageHeading
        title='Aivy Assistent Intro'
        subtitle='Karl Klammer (1997) wird zum Aivy Assistenten (2026)'
        withActions={
          <Button.SecondaryXL
            onClick={() => introRef.current?.replay()}
            text='Nochmal abspielen'
          />
        }
      />
      <div className='max-w-5xl px-4 py-8 sm:px-6 lg:px-8'>
        <AivyAssistantIntro ref={introRef} className='border border-gray-200' />
      </div>
    </Fragment>
  )
}

export default AssistantIntro
